export const renderViewFieldElement = (condition: any, renderItem?: JSX.Element | string) => {
  if (!renderItem) return condition ? condition : '-';
  return condition ? renderItem : '-';
};
